// import CurrentTrackInfo from './CurrentTrackInfo';

export function PinnedMessage({ pinnedMessage, isAdmin, onUnpin }) {
  if (!pinnedMessage) {
    return (
      <div className="mb-6 p-4 bg-red-100 text-red-800 text-center font-bold rounded-lg border-2 border-red-400">
        NO MESSAGE PINNED
      </div>
    );
  }

  // Format the expiration time if it exists
  const expiresAt = pinnedMessage.expiresAt?.toDate();
  const now = new Date();
  const timeRemaining = expiresAt ? Math.max(0, Math.floor((expiresAt - now) / 1000)) : null;
  
  let timeDisplay = '';
  if (timeRemaining !== null) {
    if (timeRemaining <= 0) {
      timeDisplay = 'Expired';
    } else if (timeRemaining < 60) {
      timeDisplay = `${timeRemaining}s remaining`;
    } else if (timeRemaining < 3600) {
      timeDisplay = `${Math.floor(timeRemaining / 60)}m remaining`;
    } else {
      timeDisplay = `${Math.floor(timeRemaining / 3600)}h ${Math.floor((timeRemaining % 3600) / 60)}m remaining`;
    }
  }

  return (
    <div className="mb-6 animate-pulse bg-red-500 p-1 rounded-lg">
      <div className="bg-yellow-300 p-4 rounded-lg">
        <div className="flex items-center justify-between mb-2">
          <div>
            <h3 className="text-2xl font-black text-red-600">
              📌 PINNED MESSAGE 📌
            </h3>
            <div className="text-sm">
              <span className="text-gray-600">
                Pinned by {pinnedMessage.pinnedByName}
              </span>
              {timeDisplay && (
                <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs">
                  {timeDisplay}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-lg border-4 border-red-500">
          <div className="flex items-start gap-3">
            {/* <img
              src={pinnedMessage.message?.userPhoto || 'https://via.placeholder.com/40'}
              alt={pinnedMessage.message?.userName}
              className="w-10 h-10 rounded-full border-2 border-yellow-400"
            /> */}
            <div>
              <p className="font-bold text-lg">
                {pinnedMessage.message?.userName}: {pinnedMessage.message?.text}
              </p>
              {/* {pinnedMessage.message?.currentTrack && (
                <CurrentTrackInfo track={pinnedMessage.message.currentTrack} />
              )} */}
            </div>
          </div>
          {isAdmin && (
            <button
              onClick={onUnpin}
              className="px-4 py-2 bg-red-500 text-white rounded-lg font-bold"
            >
              UNPIN
            </button>
          )}
        </div>
      </div>
    </div>
  );
}